module.exports = __webpack_public_path__ + "assets/details-chf.a8768219.svg";